import styled from "styled-components";

const FundEditModal = styled.div`
  position: relative;
  height: 100%;
  h2 {
    color: ${({ theme }) => theme.palette.secondary.main};
    font-weight: bold;
    margin: 0 0 0.5em;
    padding-top: 1em;
  }
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  label,
  input,
  select,
  .avps_FieldsSelect {
    font-size: 17px;
    min-width: 300px;
  }

  .avps_FieldsTextarea {
    margin: 16px 0 8px 20px;
  }

  h4 {
    margin: 0.5em 0 0;
    padding: 0;
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 500;
  }
  .avp-label {
    font-size: 17px;
    color: ${({ theme }) => theme.palette.primary.main};
  }
  textarea {
    color: ${({ theme }) => theme.palette.primary.light};
    font-size: 17px;
    font-weight: normal;
  }
  .avp-section {
    width: 100%;
  }
  .avp-item {
    width: 42%;
  }
  .selectField {
    width: 90%;
  }
  .DialogContent {
    display: flex;
    flex-flow: row;
    padding: 0 !important;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .FormGroup {
    margin: 1em 0;
  }
  .helper-text {
    font-size: 17px;
    color: #ccc;
    padding-bottom: 25px;
    margin-left: 25px;
    font-weight: 100;
  }
  .addSection {
    width: 100%;
  }
`;

export default FundEditModal;
